export const mutations = {
  SET_FILTER_FIELD(state, payload) {
    state[payload.collection].filtros[payload.field] =
      payload.value
  },

  SET_FILTER_PAGE(state, payload) {
    state[payload.collection].pagina = payload.value
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/vuetableState/mutations.js